export enum ButtonType {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  TERTIARY = 'tertiary',
  TERTIARY_ICON = 'tertiary-icon',
  PRIMARY_ICON = 'primary-icon',
  SECONDARY_ICON = 'secondary-icon',
  DOUBLE_ICON = 'double-icon',
  BACK_TO_TOP = 'back-to-top',
  SQUARED_PRIMARY = 'squared-primary',
  SQUARED_SECONDARY = 'squared-secondary',
  ROUNDED_PRIMARY = 'rounded-primary-reduced',
  ROUNDED_SECONDARY = 'rounded-secondary-reduced',
  ROUNDED_TERTIARY = 'rounded-tertiary-reduced',
  SEARCH = 'search',
  SEARCH_NO_BG = 'squared-primary-no-bg',
  LOGIN = 'login',
  MENU = 'menu',
  DROPDOWN = 'dropdown',
  EXIT = 'exit',
  OPEN_CLOSE = 'openclose',
  OPEN_CLOSE_SECONDARY = 'openclose-secondary',
  CHILDREN = 'children',
}
